export var Status;
(function (Status) {
    Status["awaitingResponse"] = "awaiting";
    Status["ok"] = "ok";
    Status["warning"] = "warning";
    Status["error"] = "error";
})(Status || (Status = {}));
export var ServerRequestType;
(function (ServerRequestType) {
    ServerRequestType["CREATE_CLASSROOM"] = "CREATE_CLASSROOM";
    ServerRequestType["DELETE_CLASSROOM"] = "DELETE_CLASSROOM";
    ServerRequestType["JOIN_CLASSROOM"] = "JOIN_CLASSROOM";
    ServerRequestType["LEAVE_CLASSROOM"] = "LEAVE_CLASSROOM";
    ServerRequestType["CREATE_COURSE"] = "CREATE_COURSE";
    ServerRequestType["DELETE_COURSE"] = "DELETE_COURSE";
    ServerRequestType["ADD_COURSE_DATA"] = "ADD_COURSE_DATA";
    ServerRequestType["PACK_COURSE"] = "PACK_COURSE";
})(ServerRequestType || (ServerRequestType = {}));
//# sourceMappingURL=wire-format.js.map